import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { SimpleDropdown } from '@/components/ui/simple-dropdown';
import { FILELOG_FIELDS, FIELD_ENUM_VALUES } from '../condition-utils';
import type { AnswerOptionCondition } from 'shared/types/due-diligence';

interface FieldValueEditorProps {
  condition: AnswerOptionCondition;
  onUpdate: (updates: Partial<AnswerOptionCondition>) => void;
}

export function FieldValueEditor({ condition, onUpdate }: FieldValueEditorProps) {
  const operatorOptions = [
    { value: '==', label: 'Gelijk aan (==)' },
    { value: '!=', label: 'Niet gelijk aan (!=)' },
    { value: 'contains', label: 'Bevat' },
    { value: 'not_empty', label: 'Niet leeg' },
    { value: 'is_empty', label: 'Is leeg' },
  ];

  const currentField = condition.field || '';
  const currentOperator = condition.operator || '==';
  const showValueField = currentOperator !== 'not_empty' && currentOperator !== 'is_empty';

  const handleFieldChange = (value: string) => {
    const enumValues = FIELD_ENUM_VALUES[value];
    onUpdate({
      field: value,
      value: enumValues?.[0]?.value || '',
    });
  };

  const renderValueInput = () => {
    if (!showValueField) return null;
    const enumValues = FIELD_ENUM_VALUES[currentField];

    if (enumValues?.length) {
      return (
        <div className="space-y-2">
          <Label className="text-sm font-medium">Waarde</Label>
          <SimpleDropdown
            value={String(condition.value || enumValues[0].value)}
            onChange={(value) => onUpdate({ value })}
            options={enumValues}
            placeholder="Selecteer waarde..."
          />
        </div>
      );
    }

    return (
      <div className="space-y-2">
        <Label className="text-sm font-medium">Waarde</Label>
        <Input
          placeholder="bijv. true, 2024-01-01, tekst..."
          value={String(condition.value || '')}
          onChange={(e) => onUpdate({ value: e.target.value })}
          className="text-sm"
        />
      </div>
    );
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm font-medium">Veld</Label>
          <SimpleDropdown
            value={currentField}
            onChange={handleFieldChange}
            options={FILELOG_FIELDS}
            placeholder="Selecteer veld..."
          />
        </div>
        <div className="space-y-2">
          <Label className="text-sm font-medium">Operator</Label>
          <SimpleDropdown
            value={currentOperator}
            onChange={(value) => onUpdate({ operator: value as AnswerOptionCondition['operator'] })}
            options={operatorOptions}
            placeholder="Selecteer operator..."
          />
        </div>
      </div>
      {renderValueInput()}
    </div>
  );
}
